import { Record } from 'immutable';
import { PurchaseMethods, ModelYear } from '@sm360/widget-commons-vehicle';

const { EXTERIOR_COLOUR_STATUSES } = ModelYear;
const { PurchaseMethodsModel, PurchaseMethodsValues } = PurchaseMethods;

const ModelRecord = Record({
    make: '',
    model: '',
    bodyStyleCode: '',
    bodyStyle: '',
    bodyStyleCodeOriginal: '',

    exteriorColours: {
        photo1: '',
        photo2: '',
        photo3: '',
    },

    exteriorColourStatus: EXTERIOR_COLOUR_STATUSES.IMAGE_STATUS.NO_IMAGE,
    purchaseMethods: new PurchaseMethodsModel(),

    rebate: 0.0,
    highRebate: 0.0,
    highRebatePurchaseMethod: PurchaseMethodsValues.CASH,

    financeModelDisclaimer: '',
    leaseModelDisclaimer: '',
    priceModelDisclaimer: '',
    priceExclusionsDisclaimer: '',

    priceYear: 0,
    priceModelTrimCode: '',
    priceConfigurationId: 0,

    leaseYear: 0,
    leaseModelTrimCode: '',
    leaseConfigurationId: 0,

    financeYear: 0,
    financeModelTrimCode: '',
    financeConfigurationId: 0,

    makeVisible: true,
    modelVisible: true,
    bodyStyleVisible: true,
    visible: true,
});

class Model extends ModelRecord {}

export default Model;
